<template>
  <div 
    class="calendar-main-time-block-task"
    @click="$emit('setDateToTask', currentDay.day, time.time, $event)"
  >
    <Draggable
      ref="draggable1"
      class="calendar-drag"
      @change="$emit('moved', { ...$event, time, currentDay })"
      v-model="time.tasks"
      :force-fallback="true"
      :fallbackTolerance="5"
      :scroll-sensitivity="100"
      group="tasks"
    >
      <TaskWrapper
        v-for="task in time.tasks"
        :key="task.id"
        :task="task"
        :newClass="handlerStyleTags(task)"
        @changeTask="changeTask"
      />
    </Draggable>
  </div>
</template>

<script>
import TaskWrapper from '@/components/calendar/TaskWrapper';
import Draggable from "vuedraggable";

export default {
  components: {
    TaskWrapper,
    Draggable,
  },
  props: {
    time: {
      type: Object,
      default: () => {},
    },
    currentDay: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handlerStyleTags(task) {
      if (task.order_id) {
        return 'tags-style-order_id'
      }
      if (task.company_id) {
        return 'tags-style-company_id'
      }
      if (task.order_service_id) {
        return 'tags-style-order_service_id'
      }
      if (task.finance_id) {
        return 'tags-style-finance_id'
      }
      return 'tags-style-notification'
    },
    changeTask(task) {
      this.$emit('changeTask', task)
    },
  },
}
</script>